<app-navbar></app-navbar>
<div>
    <!-- <div *ngIf="authService.init"> -->
    <router-outlet></router-outlet>
</div>

<app-modal *ngIf="modalService.showModal"></app-modal>

<app-advise-banner></app-advise-banner>